export const Alert = () => import('../..\\..\\..\\components\\Alert.vue' /* webpackChunkName: "components/alert" */).then(c => wrapFunctional(c.default || c))
export const Badge = () => import('../..\\..\\..\\components\\Badge.vue' /* webpackChunkName: "components/badge" */).then(c => wrapFunctional(c.default || c))
export const Button = () => import('../..\\..\\..\\components\\Button.vue' /* webpackChunkName: "components/button" */).then(c => wrapFunctional(c.default || c))
export const CardColor = () => import('../..\\..\\..\\components\\CardColor.vue' /* webpackChunkName: "components/card-color" */).then(c => wrapFunctional(c.default || c))
export const Carousel = () => import('../..\\..\\..\\components\\Carousel.vue' /* webpackChunkName: "components/carousel" */).then(c => wrapFunctional(c.default || c))
export const Checkbox = () => import('../..\\..\\..\\components\\Checkbox.vue' /* webpackChunkName: "components/checkbox" */).then(c => wrapFunctional(c.default || c))
export const ContactForm = () => import('../..\\..\\..\\components\\ContactForm.vue' /* webpackChunkName: "components/contact-form" */).then(c => wrapFunctional(c.default || c))
export const DotNav = () => import('../..\\..\\..\\components\\DotNav.vue' /* webpackChunkName: "components/dot-nav" */).then(c => wrapFunctional(c.default || c))
export const Footer = () => import('../..\\..\\..\\components\\Footer.vue' /* webpackChunkName: "components/footer" */).then(c => wrapFunctional(c.default || c))
export const Grid = () => import('../..\\..\\..\\components\\Grid.vue' /* webpackChunkName: "components/grid" */).then(c => wrapFunctional(c.default || c))
export const Header = () => import('../..\\..\\..\\components\\Header.vue' /* webpackChunkName: "components/header" */).then(c => wrapFunctional(c.default || c))
export const IconButton = () => import('../..\\..\\..\\components\\IconButton.vue' /* webpackChunkName: "components/icon-button" */).then(c => wrapFunctional(c.default || c))
export const Input = () => import('../..\\..\\..\\components\\Input.vue' /* webpackChunkName: "components/input" */).then(c => wrapFunctional(c.default || c))
export const LoadingBar = () => import('../..\\..\\..\\components\\LoadingBar.vue' /* webpackChunkName: "components/loading-bar" */).then(c => wrapFunctional(c.default || c))
export const Menu = () => import('../..\\..\\..\\components\\Menu.vue' /* webpackChunkName: "components/menu" */).then(c => wrapFunctional(c.default || c))
export const Select = () => import('../..\\..\\..\\components\\Select.vue' /* webpackChunkName: "components/select" */).then(c => wrapFunctional(c.default || c))
export const TabsList = () => import('../..\\..\\..\\components\\TabsList.vue' /* webpackChunkName: "components/tabs-list" */).then(c => wrapFunctional(c.default || c))
export const TextArea = () => import('../..\\..\\..\\components\\TextArea.vue' /* webpackChunkName: "components/text-area" */).then(c => wrapFunctional(c.default || c))
export const TextDecoration = () => import('../..\\..\\..\\components\\TextDecoration.vue' /* webpackChunkName: "components/text-decoration" */).then(c => wrapFunctional(c.default || c))
export const Toggle = () => import('../..\\..\\..\\components\\Toggle.vue' /* webpackChunkName: "components/toggle" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
